import { render, staticRenderFns } from "./DeliveryFormProducts.vue?vue&type=template&id=b198a590&scoped=true&"
import script from "./DeliveryFormProducts.vue?vue&type=script&lang=ts&"
export * from "./DeliveryFormProducts.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryFormProducts.vue?vue&type=style&index=0&id=b198a590&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b198a590",
  null
  
)

export default component.exports